import { useMediaQuery } from 'react-responsive'

export default () => {
  const isMobile = useMediaQuery({ maxWidth: 1280 })
  const isDesktop = useMediaQuery({ minWidth: 1280 })

  return {
    isMobile,
    isDesktop,
  }
}
